
export const cookieHelper = {
    setAuthCookie, 
    setRefreshCookie,
    getCookie,
    getAuthToken,
    getRefreshToken,
    deleteCookie,
    deleteAllCookies,
}

function setAuthCookie(accessToken){
    // authentication cookies
    document.cookie = `access_token=${accessToken}; Secure;path=/;`;
}

function setRefreshCookie(refreshToken){
    document.cookie = `refresh_token=${refreshToken}; Secure;path=/;`;
}

function getCookie(cookieName){
    const cookies = document.cookie.split(';');
    
    let cookieData = '';
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === cookieName) {
        cookieData = value;
      }
    }
    return cookieData;
}

function deleteCookie(cookieName){
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function deleteAllCookies(){
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        if(name.trim() == 'access_token' || name.trim() == 'refresh_token'){
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;"; // Add path if necessary
        }
    }
}

function getAuthToken(){
    const cookies = document.cookie.split(';');
    
    let token = '';
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'access_token') {
        token = value;
      }
    }
    return token;
}


function getRefreshToken(){
    const cookies = document.cookie.split(';');
    let token = '';
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'refresh_token') {
        return value;
      }
    }
    return token;
}

